// The PerimeterX SDK (injected via BotProtection) renders the "Press & Hold"
// challenge inline and invokes `window._pxOnCaptchaSuccess(isValid)` once the
// user interacts with it. We hook that callback to know when the original
// request can be safely retried with the refreshed cookies.

// If the SDK contract changes (or the user never solves the challenge), fall
// back after this timeout so the request rejects normally instead of hanging.
const PERIMETERX_CHALLENGE_TIMEOUT_MS = 30_000;

// Shared across concurrently-challenged requests so a single solve retries all
// of them, rather than each request wiring its own callback (which would
// clobber the others).
let inFlight: Promise<void> | null = null;

export const waitForPerimeterXChallenge = (): Promise<void> => {
  if (inFlight) {
    return inFlight;
  }

  inFlight = new Promise<void>((resolve, reject) => {
    const previous = window._pxOnCaptchaSuccess;

    const restore = () => {
      window._pxOnCaptchaSuccess = previous;
    };

    const timeoutId = window.setTimeout(() => {
      restore();
      reject(new Error('PerimeterX challenge timed out'));
    }, PERIMETERX_CHALLENGE_TIMEOUT_MS);

    window._pxOnCaptchaSuccess = (isValid: boolean) => {
      previous?.(isValid);

      if (isValid) {
        window.clearTimeout(timeoutId);
        restore();
        resolve();
      }
    };
  }).finally(() => {
    inFlight = null;
  });

  return inFlight;
};
